export function setFocusTrap(trap) {
  if (!trap) return;

  window.wlcrFocusTrap.active = trap;
}

export function unsetFocusTrap() {
  if (!window.wlcrFocusTrap) return;

  window.wlcrFocusTrap.active = null;
}

export function getActiveFocusTrap() {
  if (!window.wlcrFocusTrap) return;

  return window.wlcrFocusTrap.active;
}

/**
 * Create global focus trap property on window object
 */
export function focusTrap() {
  window.wlcrFocusTrap = {};
}
